import * as types from '../actionTypes/CouponsActionTypes';

function CouponsReducer(state = {}, action = {}) {
    if (action.type === types.GET_COUPONS_SUCCESS) {
        const { couponsPayload } = action;
        return { ...state, ...couponsPayload };
    }
    return state;
}

CouponsReducer.reducerName = 'couponsDetails';
export default CouponsReducer;
